class EventEmitterService extends EventTarget {
  constructor() {
    super();
    // console.log('Internal EventEmitterService created.'); // For debugging
  }

  emit(eventName, detail) {
    this.dispatchEvent(new CustomEvent(eventName, { detail }));
  }

  on(eventName, handler) {
    this.addEventListener(eventName, handler);
  }

  off(eventName, handler) {
    this.removeEventListener(eventName, handler);
  }
}

export const internalEventEmitter = new EventEmitterService();
